<template>
  <v-card
    outlined
    class="blob__suggestion"
  >
    <v-list-item three-line-line>
      <v-list-item-content>
        <div class="overline mb-4">
          <v-chip-group column>
            <v-chip
                v-for="(tag, i) in blob.tags"
                :key="i"
                small
                disabled
                color="orange darken-4"
                outlined
            >{{ tag }}
            </v-chip>
          </v-chip-group>
        </div>
        <v-list-item-title class="headline mb-1">
          {{ blob.name }}
        </v-list-item-title>
      </v-list-item-content>
      <v-list-item-avatar
          height="80"
          width="220"
          color="transparent"
          tile
      >
        <v-img
            v-if="blob.image"
            :src="blob.image"
            max-height="120"
        ></v-img>
      </v-list-item-avatar>
    </v-list-item>
    <v-card-text>
      <v-divider></v-divider>
      <br>
      <div>
        {{ blob.description }}
      </div>
      <a :href="blob.link" target="_blank">{{ blob.link|cleanUrl }}</a>
    </v-card-text>

    <v-card-actions class="pa-4">
      <v-spacer></v-spacer>

      <v-btn
          dark
          color="orange darken-2"
          @click="copy(blob)"
      >
        <v-icon left>mdi-share</v-icon>
        {{ $t('blob.suggestions.actions.add') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'Details',
  props: {
    blob: {
      type: Object,
      required: true
    }
  },
  methods: {
    copy (blob) {
      this.$store.commit('linking/newLinking', {
        quadrant: blob.quadrant,
        sector: blob.sector,
        blobId: blob.id,
        name: blob.name,
        copy: true
      })
    }
  }
}
</script>

<style lang="scss">
.blob__suggestion {
  border-color: #f57c00 !important;

  a {
    color: #000000;
  }

  .v-image__image.v-image__image--cover {
    background-size: contain !important;
  }
}
</style>
